angular.module('tgaApp').controller('SplashController', [
  '$scope',
  'settingsService',
  '$uibModal',
  'analyticsService',
  'scormService',
  'userService',
  'soundService',
  'gameConfig',
  '$log',
  '$timeout',
  function (
    $scope,
    settingsService,
    $uibModal,
    analyticsService,
    scormService,
    userService,
    soundService,
    gameConfig,
    $log,
    $timeout,
  ) {
    $scope.initialize = function () {
      // splash screen stuff
      $log.debug('Splash Screen state');
      const defaultSplashBackground = null;
      const defaultSplashTitle = './assets/images/logo.png';
      $scope.splashBackground = $scope.game.splash.background.type
        ? $scope.game.splash.background.image.url
        : defaultSplashBackground;
      $scope.privacyLink = 'https://www.elblearning.com/legal/privacy-policy/';
      $scope.companyPrivacyLink = $scope.game.privacy_policy_url;
      $scope.companyPrivacyName = $scope.game.privacy_policy_name;

      $scope.legalLink = 'https://www.elblearning.com/legal/subscription-and-license-agreement/';
      $scope.companyLegalLink = $scope.game.legal_url;
      $scope.companyLegalName = $scope.game.legal_name;

      if ($scope.game.splash.logo.text) {
        $scope.splashLogoText = $scope.game.splash.logo.text;
      } else if ($scope.game.splash.logo.image.url) {
        $scope.splashLogoImg = $scope.game.splash.logo.image.url;
      }

      if ($scope.game.splash.title.text) {
        $scope.splashTitleText = $scope.game.splash.title.text;
      } else if ($scope.game.splash.title.image.url) {
        $scope.splashTitleImg = $scope.game.splash.title.image.url;
      } else if ($scope.game.splash.title.type === 'default') {
        $scope.splashTitleImg = defaultSplashTitle;
      }

      $scope.sfxArray = [
        {
          src: './assets/sounds/ticking.mp3',
          id: 'ticking',
          volume: 0.1,
          loop: true,
        },
        {
          src: './assets/sounds/correct.mp3',
          id: 'correct',
          volume: gameConfig.sfxVolume,
        },
        {
          src: './assets/sounds/wrong.mp3',
          id: 'wrong',
          volume: gameConfig.sfxVolume,
        },
        {
          src: './assets/sounds/click.mp3',
          id: 'click',
          volume: gameConfig.sfxVolume,
        },
        {
          src: './assets/sounds/times-up.mp3',
          id: 'times-up',
          volume: gameConfig.sfxVolume,
        },
        {
          src: './assets/sounds/complete.mp3',
          id: 'complete',
          volume: gameConfig.sfxVolume,
        },
        {
          src: './assets/sounds/whoosh.mp3',
          id: 'whoosh',
          volume: gameConfig.sfxVolume,
        },
        {
          src: './assets/sounds/beep.mp3',
          id: 'beep',
          volume: 0.25,
        },
        {
          src: './assets/sounds/beep2.mp3',
          id: 'beep2',
          volume: 0.25,
        },
      ];

      soundService.loadMultiple($scope.sfxArray);
      $timeout(
        () => {
          $scope.splashLoaded = true;
        },
      );
    };

    $scope.continue = function () {
      if (!gameConfig.sfx_muted) {
        soundService.play('click');
      }

      // fixes muted audio
      if (!gameConfig.music_muted) {
        soundService.play('blank');
      }

      // if there is game info popup
      if ($scope.game.popup && ($scope.game.popup.title || $scope.game.popup.body)) {
        $scope.showInfo = true;
      } else {
        // no popup
        $scope.registerOrNot();
      }
    };

    // decide if we go to registration or tutorial state
    $scope.registerOrNot = function () {
      $scope.showInfo = false;

      // bypass reg if url param says so
      if ($scope.URLParams.bypass_reg === 'true' && $scope.URLParams.username !== null) {
        userService.register($scope.URLParams).then(() => {
          if ($scope.game.tutorial) {
            // $scope.setState('tutorial');
            $scope.setState('game');
          } else {
            $scope.setState('game');
          }

          $scope.analyticsService.sendEvent({
            category: 'player action',
            action: 'button clicked',
            label: 'registration submit',
          });
        });
      } else if (scormService.isConnected()) {
        // if scorm user
        const scormUser = scormService.provideUser();

        $scope.registration = {
          display_name: scormUser.name,
          first_name: scormUser.name,
          username: scormUser.id,
        };

        userService.register($scope.registration).then(() => {
          // $scope.setState('tutorial');
          $scope.setState('game');
          $scope.analyticsService.sendEvent({
            category: 'player action',
            action: 'button clicked',
            label: 'registration submit',
          });
        });
      } else if ($scope.game.registration.required || $scope.game.show_leaderboard) {
        // register state if reg required or show leaderboard
        $scope.setState('register');
      } else {
        // register anonymous user
        userService.register().then(() => {
          $scope.setState('game');
        });
      }
    };

    $scope.initialize();
  },
]);
